import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../primitives/base/select'
import { Input } from '../primitives/input'
import { Label } from '../primitives/label'

interface APIUrlInputProps {
  methods?: string[]
  defaultMethod?: string
  placeholder?: string
  onMethodChange?: (method: string) => void
  onUrlChange?: (url: string) => void
  className?: string
  label?: string
  url?: string
  endIcon?: React.ReactNode
  id: string
}

export const ApiUrlInput = ({
  methods = ['GET', 'POST', 'PUT', 'DELETE'],
  defaultMethod = 'GET',
  placeholder = 'Enter a URL to make HTTP request',
  onMethodChange,
  onUrlChange,
  className = '',
  label,
  url,
  endIcon,
  id,
}: APIUrlInputProps) => {
  // Convert form method to uppercase for display
  const currentMethod = defaultMethod.toUpperCase()

  return (
    <div className={`grid items-center gap-1.5 w-full ${className}`}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <div className="flex w-full overflow-hidden rounded-md border border-input ring-offset-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2">
        <Select key={currentMethod} defaultValue={currentMethod} onValueChange={onMethodChange}>
          <SelectTrigger className="w-[100px] rounded-none border-none bg-background font-jetbrains text-xs-500 tracking-normal focus:ring-0">
            <SelectValue placeholder="Method" />
          </SelectTrigger>
          <SelectContent>
            {methods.map((m) => (
              <SelectItem key={m} value={m} className="font-jetbrains text-xs-500 tracking-normal">
                {m}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <div className="w-px bg-input" />
        <Input
          id={id}
          type="text"
          inputMode="url"
          placeholder={placeholder}
          value={url}
          onChange={(e) => onUrlChange?.(e.target.value)}
          className="flex-grow border-none focus-visible:ring-0 rounded-none"
          endIcon={endIcon}
        />
      </div>
    </div>
  )
}
